import * as React from "react";
import { ShiftsCrews } from "./ShiftsCrewsPage";
import { ShiftsCrewsProvider } from "./context/ShiftsCrewsContext";

type Props = {};

const ShiftsCrewsPage = (props: Props) => {
	return (
		<ShiftsCrewsProvider>
			<ShiftsCrews />
		</ShiftsCrewsProvider>
	);
};

export default ShiftsCrewsPage;
